import useKeyBinding from "../hooks/useKeyBinding"

export interface KeyboardShortcutsProps {
	onToggleJamMode: () => void
}

export default function KeyboardShortcuts(props: KeyboardShortcutsProps) {
	// type j a m to turn on/off jam
	useKeyBinding("j a m", () => {
		props.onToggleJamMode()
	})

	useKeyBinding("p a m", () => {
		console.log("missing the office")
	})

	return null
}
